export default __webpack_public_path__ + "static/media/sort_up.fb0aa0ee.svg";